var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"mb-2 ml-4 text-caption"},[(item)?[_c('div',{domProps:{"innerHTML":_vm._s(item)}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }